<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Aggiungi Attività
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-if="step == 1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickAvanti"
              v-bind="attrs"
              v-on="on"
              small
              :disabled="!macchina"
            >
              <v-icon color="success">mdi-keyboard-backspace mdi-rotate-180</v-icon>
            </v-btn>
          </template>
          <span>Avanti</span>
        </v-tooltip>
      </template>

      <template v-if="step == 2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickIndietro"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </template>
          <span>Avanti</span>
        </v-tooltip>
      </template>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickChiudi"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text style="overflow-y: auto">
      <template v-if="step == 1">
        <v-row class="mt-1 text-left">
          <v-col>
            <h2>Seleziona il macchinario</h2>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select
              label="Macchina"
              dense
              outlined
              hide-details
              v-model="macchina"
              :items="macchine"
              item-text="des_macchina"
              item-value="id_macchina"
            >
            </v-select>
          </v-col>
        </v-row>
      </template>

      <template v-if="step == 2">
        <v-row class="mt-1">
          <v-col>
            <h3 class="mb-2">Stato macchina</h3>

            <template v-if="statoMacchina == 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="1"
                    x-large
                    color="white"
                    class="button-macchina-bloccata"
                    style="height: 80px; width: 92px;"
                    @click="cambiaStatoMacchina(1)"
                  >
                    <v-icon
                      color="white"
                      style="font-size: 40px"
                    >
                      mdi-minus-thick
                    </v-icon>
                  </v-btn>
                </template>
                <span>Bloccata</span>
              </v-tooltip>
            </template>

            <template v-if="statoMacchina == 1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="1"
                    x-large
                    color="white"
                    class="button-macchina-disponibile"
                    style="height: 80px; width: 92px"
                    @click="cambiaStatoMacchina(0)"
                  >
                  </v-btn>
                </template>
                <span>Disponibile</span>
              </v-tooltip>
            </template>
          </v-col>

          <v-col>
            <h3 class="mb-2">Stato Attività</h3>

            <template v-if="statoIntervento == 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="1"
                    x-large
                    color="success"
                    style="height: 80px"
                    @click="avviaIntervento()"
                  >
                    <v-icon
                      color="white"
                      style="font-size: 40px"
                    >
                      mdi-play
                    </v-icon>
                  </v-btn>
                </template>
                <span>Avvia intervento</span>
              </v-tooltip>
            </template>

            <template v-if="statoIntervento == 1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    elevation="1"
                    x-large
                    color="white"
                    style="height: 80px; width: 92px"
                    class="button-stop-intervento"
                    @click="stopIntervento()"
                  >
                    <v-icon
                      color="orange"
                      style="font-size: 40px"
                    >
                      mdi-play
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ferma intervento</span>
              </v-tooltip>
            </template>
          </v-col>
        </v-row>
      </template>

      <template v-if="step == 3">
        <v-row class="mt-1">
          <v-col>
            <h3 class="mb-2">Sospendi intervento</h3>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  elevation="1"
                  x-large
                  color="white"
                  class="button-sospendi-intervento"
                  style="height: 80px"
                  @click="sospendiIntervento()"
                >
                  <v-icon
                    color="white"
                    style="font-size: 40px"
                  >
                    mdi-minus-thick
                  </v-icon>
                </v-btn>
              </template>
              <span>Sospendi intervento</span>
            </v-tooltip>
          </v-col>

          <v-col>
            <h3 class="mb-2">Concludi intervento</h3>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  elevation="1"
                  x-large
                  color="white"
                  class="button-concludi-intervento"
                  style="height: 80px"
                  @click="concludiIntervento()"
                >
                  <v-icon
                    color="white"
                    style="font-size: 40px"
                  >
                    mdi-check-bold
                  </v-icon>
                </v-btn>
              </template>
              <span>Concludi intervento</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AggiungiIntervento",
  props: {
    macchine: { type: Array, default: () => [] },
  },
  data() {
    return {
      step: 1,

      statoMacchina: 1,
      statoIntervento: 0,

      macchina: '',
    };
  },
  methods: {
    clickChiudi() {
      this.macchina = null;
      this.$emit("click_chiudi");
    },
    clickAvanti() {
      this.step = 2;
    },
    clickIndietro() {
      this.step = 1;
    },
    cambiaStatoMacchina(stato) {
      this.statoMacchina = stato;
    },
    avviaIntervento() {
      this.statoIntervento = 1;
    },
    stopIntervento() {
      this.step = 3;
    },
    sospendiIntervento() {
      this.$emit("click_sospendi_intervento");
    },
    concludiIntervento() {
      this.$emit("click_concludi_intervento");
    },
  },
};
</script>

<style>
.button-stop-intervento .v-btn__content {
  border: 4px dashed orange;
  border-radius: 35px;
  height: 70px;
  width: 70px;
}
.button-macchina-disponibile .v-btn__content {
  border-radius: 35px;
  height: 70px;
  width: 70px;
  background-color: #8bc34a !important;
}
.button-macchina-bloccata .v-btn__content {
  border-radius: 35px;
  height: 70px;
  width: 70px;
  background-color: #ff5722 !important;
}
.button-sospendi-intervento .v-btn__content {
  border-radius: 35px;
  height: 70px;
  width: 70px;
  background-color: #9c27b0!important;
}
.button-concludi-intervento .v-btn__content {
  border-radius: 35px;
  height: 70px;
  width: 70px;
  background-color: #8bc34a !important;
}
</style>
